import { cb, isAndroid, isChangba, isIOS, isInvalidChangba, isMars, isMarsProject, isOutChangba, isQQorWeChat, isWeibo, isWXMP, mars, ua, } from './config';
import { getAppVersion, getQuery, getUserId, getGlobalParams, compareVersion, extractExistUrlParams } from './params';
import * as CryptoJS from 'crypto-js';
/**
 * AES加密的key
 */
var encryptKey = 'ChangbaActivityEncryptKeyABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
/**
 * AES加密的初始化向量（IV）
 */
var encryptIv = 'ChangbaActivityInitialVector';
export function decrypt(text) {
    return CryptoJS.AES.decrypt(text, encryptKey, { iv: encryptIv }).toString(CryptoJS.enc.Utf8);
}
export var env = {
    get ua() {
        return ua;
    },
    get version() {
        return {
            mars: mars,
            cb: cb,
        };
    },
    get browser() {
        return {
            isAndroid: isAndroid,
            isIOS: isIOS,
            isQQorWeChat: isQQorWeChat,
            isWeibo: isWeibo,
            isWXMP: isWXMP,
            isOutChangba: isOutChangba,
            isInvalidChangba: isInvalidChangba,
            isMars: isMars,
            isMarsProject: isMarsProject,
            isChangba: isChangba,
        };
    },
    get userInfo() {
        var token = getQuery('token');
        var userId = getUserId();
        return {
            token: token,
            userId: userId,
        };
    },
    get webviewType() {
        // url如果不设置show_mode，则默认走唱吧 11.2.0 版本之前的内置浏览器。
        var showModeParam = getQuery('show_mode');
        if (showModeParam && isChangba) {
            return 'new';
        }
        return 'old';
    },
};
export { ua, getAppVersion, getQuery, getGlobalParams, getUserId, compareVersion, extractExistUrlParams };
